<a [href]="viewUnitIntranetUrl" target="_blank" rel="noopener">{{ 'KEY_FACTS.viewUnitIntranet' | translate }}</a>
